import DashboardLayout from "../../../layoutcontainers/DashboardLayout";
import { Box, Card, CardHeader, IconButton, Stack } from "@mui/material";
import MaterialTypography from "../../../components/MaterialTypography";
import { useNavigate } from "react-router-dom";
import { postData } from "../../../services";
import { ArrowBack } from "@mui/icons-material";
import { MotorBodyStyleForm } from "./components/motorBodyStyleForm";
import { useSnackbar } from "../../../context/popup";
import { useLoading } from "../../../components/Loading";

const AddMotorBodyStyle = () => {
  
  const navigate = useNavigate();
  const { showSnackbar } = useSnackbar();
  const { setCircleLoading } = useLoading();

  const handleAddBodyStyle = async (bodyStyleData) => {
    setCircleLoading(true);
    try {
      const bodyStylePostData = {
        name: bodyStyleData.name,
        motorBodyTypeId: bodyStyleData.motorBodyType?.value,
        isActive: bodyStyleData.active,
      };

      const response = await postData(
        "/reference/motor/bodystyle",
        bodyStylePostData
      );

      if (response?.success) {
        navigate("/motor-master/motor-bodyStyle");
        showSnackbar(response?.message, "success");
      } else {
        showSnackbar(response?.message,"error");
      }
    } catch (error) {
      console.error("Error Submitting",error);
      showSnackbar(error?.response?.data?.message || "Network Error","error");
    }
    finally{
      setCircleLoading(false);
    }
  };

  return (
    <DashboardLayout>
      <Card>
        <CardHeader
          title={
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              spacing={2}
            >
              <Stack direction="row" alignItems="center" spacing={1}>
                <IconButton
                  onClick={() => navigate("/motor-master/motor-bodyStyle")}
                >
                  <ArrowBack />
                </IconButton>
                <Stack direction="column" spacing={0}>
                  <MaterialTypography variant="h5" fontWeight="medium">
                    Add Body Style details
                  </MaterialTypography>
                  <MaterialTypography variant="caption" color="text">
                    Add Body Style details here.
                  </MaterialTypography>
                </Stack>
              </Stack>
            </Stack>
          }
        />
        <Box>
          <MotorBodyStyleForm onsubmit={handleAddBodyStyle} />
        </Box>
      </Card>
    </DashboardLayout>
  );
};

export default AddMotorBodyStyle;
